import { datetime, date } from "../../utils";
import I18n from "../../I18n";

export const GENERATOR_STATUS = {
    0: "in_progress",
    1: "success",
    2: "error",
    3: "deleted",
    4: "pre_validation_success",
    5: "pre_validation_failed",
    6: "data_integrity_success",
    7: "data_integrity_failed",
    8: "data_integrity_in_progress",
};
export const prepareGeneratedFileByStatus = (status) => {
    const statusObj = { generationStatus: status };
    switch (status) {
        case "error":
        case "pre_validation_failed":
        case "data_integrity_failed":
            return {
                severity: "3",
                family: "error",
                ...statusObj,
            };
        case "in_progress":
        case "data_integrity_in_progress":
            return {
                severity: "1",
                family: "warning",
                ...statusObj,
            };
        case "success":
        case "pre_validation_success":
        case "data_integrity_success":
            return {
                severity: "0",
                family: "success",
                ...statusObj,
            };
        case "deleted":
            return {
                ...statusObj,
            };
        default:
            return {};
    }
};
const mapCard = (json) => {
    const {
        message,
        userName,
        fiscalYear,
        dateFrom,
        dateTo,
        fileType,
        createdAt,
        status,
        fileTypeName,
        fileName,
        id,
    } = json;
    const lineGenerationStatus = GENERATOR_STATUS[status];

    const { family, severity, generationStatus } = prepareGeneratedFileByStatus(
        (lineGenerationStatus || "").toLowerCase(),
    );
    return [
        [
            {
                labels: ["message"],
                value:
                    message !== "undefined"
                        ? I18n.translate`${message}`
                        : "The file couldn't be generated. Please contact the support.",
                align: "left",
            },
        ],
        [{ labels: ["user"], value: userName, align: "left" }],
        [
            {
                labels: ["fiscalyear"],
                value: fiscalYear,
                align: "left",
            },
        ],
        [
            {
                labels: ["date_from"],
                value: date(dateFrom),
                type: "date",
                align: "center",
            },
        ],
        [
            {
                labels: ["date_to"],
                value: date(dateTo),
                type: "date",
                align: "center",
            },
        ],
        [
            {
                labels: ["file_type"],
                value: fileType ? fileType + " - " + (fileTypeName || "N/A") : "N/A",
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["request_at"],
                value: datetime(createdAt),
                type: "datetime",
                align: "center",
            },
        ],
        [
            {
                labels: ["status"],
                value: {
                    value: status,
                    label: I18n.translate`${lineGenerationStatus || "in_progress"}`,
                    severity,
                    family,
                    color: "main",
                    generationStatus,
                },
                type: "fileStatus",
            },
        ],
        [
            {
                labels: [""],
                value: {
                    id,
                    generationStatus,
                    customComponent: "GeneratorLineMoreActions",
                    entity: "generator",
                    name: fileName,
                },
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        name: `${json.id} ${json.fileName ? ` - ${json.fileName}` : ""}`,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        detailPanel: {
            data: json?.detailPanel?.data || undefined,
            detailPanelComponent: "GeneratorListDetails",
        },
    };
};

const header = [
    { label: ["Message"], align: "left", columnName: "message" },
    { label: ["User"], align: "left", mobileHidden: true, type: "userWithAvatar" },
    { label: ["fiscalyear"], align: "left", mobileHidden: true },
    {
        label: ["date_from"],
        mobileHidden: true,
        align: "center",
    },
    {
        label: ["date_to"],
        mobileHidden: true,
        align: "center",
    },
    { label: ["file_type"], align: "center" },
    { label: ["requested_at"], mobileHidden: true, align: "center" },
    { label: ["Status"], mobileHidden: true, align: "center", type: "fileStatus" },
    { label: ["Actions"], type: "customComponent", align: "right" },
];

const generatordatafileMapper = {
    map: mapper,
    header,
    showCheckbox: true,
};

export default generatordatafileMapper;
